import { BaseMutations } from '@/store/base-mutations';
import { Repairs } from '../../../types';
import NewRepairState from './state';

export default class NewRepairMutations extends BaseMutations<NewRepairState> {
  SET_NEW_REPAIR(new_repair: Repairs.NewRepair) {
    this.state.new_repair = new_repair;
  }

  UPD_NEW_REPAIR_KEY({ key, value }: { key: keyof Repairs.NewRepair, value: unknown}) {
    this.state.new_repair[key] = value;
  }

  SET_NEW_REPAIR_CATEGORIES(categories: Repairs.Category[]) {
    this.state.new_repair_categories = categories;
  }

  SET_NEW_REPAIR_OPERATION_TYPES(operations: Repairs.OperationType[]) {
    this.state.new_repair_operation_types = operations;
  }

  ADD_NEW_REPAIR_COMPONENT(component: Repairs.ComponentPayload) {
    this.state.new_repair.complections.push(component);
  }

  DELETE_NEW_REPAIR_COMPONENT(component: Repairs.ComponentPayload) {
    this.state.new_repair.complections = this.state.new_repair.complections.filter(
      (i) => i !== component,
    );
  }

  SET_NEW_REPAIR_WARRANTY(warranty: Repairs.Warranty[]) {
    this.state.new_repair_warranty_info = warranty;

    if (warranty) {
      warranty.forEach((warranty: Repairs.Warranty) => {
        this.state.new_repair_actual_extended_warranties = warranty.extended_warranties && warranty.extended_warranties.length
          ? warranty.extended_warranties.filter((extended_warranty: Repairs.ExtendedWarranty) => extended_warranty.actual)
          : [];
      });
    }
  }

  SET_NEW_REPAIR_WARRANTY_IS_NOT(is_not_warranty_repair: boolean) {
    this.state.is_not_warranty_repair = is_not_warranty_repair;
  }

  UPD_NEW_REPAIR_OPERATION_TYPE(value: number) {
    this.state.new_repair.operation_type_id = value;
  }

  SET_IN_NOT_FOUND(is_not_found: boolean) {
    this.state.is_not_found = is_not_found;
  }

  TOGGLE_IS_PRODUCT_NOT_FOUND(value: boolean) {
    this.state.new_repair.is_product_not_found = value;
  }

  UPD_SEARCH_KEY() {
    this.state.search_key += 1;
  }

  TOGGLES_IS_SUBMITTED(value: boolean) {
    this.state.is_submitted = value;
  }
}
